module.exports = __webpack_public_path__ + "media/images/dashboard_icons/refund-48c229a9a3c5a6ecedbe22f7c7f7f53c.svg";